import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <h4>
        Copyright <span class="highlight">&copy;2020, Roman Karki </span>, all
        rights reserved
      </h4>
    </div>
  );
}

export default Footer;
